<template>
  <div class="check_offer">
    <head-top head-title="查验报价" hidden='true' go-back="true"></head-top>
    <div class="fix-style">
      <ol>
        <li>
          <router-link to="/UnderTaking" replace>
            <div>
              <span>承接查验</span>
            </div>
          </router-link>
        </li>
        <li>
          <router-link :to="{path:'/AssessMent',query:{state:2}}" replace>
            <div>
              <span>评估监理</span>
            </div>
          </router-link>
        </li>
      </ol>
    </div>
    <!--显示子路由内容部分-->
    <router-view></router-view>
  </div>
</template>

<script>
  import headTop from '../header/Header'
  export default {
    name: 'statisticsAll',
    components: {
      headTop
    }
  }
</script>

<style lang="scss" scoped>
  .check_offer {
    width: 100%;
    padding-top: 40px;
    .fix-style {
      width: 100%;
      height: 50px;
      right: 0;
      left: 0;
      position: fixed;
      z-index: 666;
      background: #077bff;
      ol {
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        li {
          width: 50%;
          text-align: center;
          a {
            width: 100%;
            color: #ffffff;
            font-size: 15px;
            font-weight: bolder;
            text-align: center;
            text-decoration: none;
            div {
              height: 50px;
              span {
                line-height: 50px;
              }
            }
          }
          a.active {
            color: #077bff;
            font-size: 15px;
            div {
              background-color: #ffffff;
              height: 50px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/my/CheckOffer.vue